import { useMemo } from 'react';

import { requiredMsg } from 'lib/constants/messages';

import { showAlert } from 'components/shared/Alert/Alert';

import { IMPORT_TYPE } from './lib';

export const useImportActions = ({ props, modals, form }) => {
  const defaultActions = useMemo(
    () => [
      {
        text: 'View past imports',
        onClick: () => modals.setShowPastImports(true),
        color: 'neutral',
        style: 'outlined'
      },
      {
        text: 'Import',
        iconRight: 'chevron-right-linear',
        iconColor: 'white',
        onClick: () => {
          if (
            form.initialImportForm.numberOfPatients === '0' ||
            form.initialImportForm.numberOfPatients === ''
          ) {
            return showAlert({ title: requiredMsg('Number of patients'), color: 'danger' });
          } else if (!form.initialImportForm.selectedType) {
            return showAlert({ title: requiredMsg('Import type'), color: 'danger' });
          }
          handleInitialFormSubmit(form.initialImportForm.selectedType);
        }
      }
    ],
    [form.initialImportForm.selectedType, form.initialImportForm.numberOfPatients]
  );

  const handleInitialFormSubmit = (selectedType) => {
    if (selectedType === IMPORT_TYPE.CSV_IMPORT) {
      modals.setShowImportCSV(true);
    } else if (selectedType === IMPORT_TYPE.SOFTWARE_EXPORT) {
      modals.setShowSoftwareExport(true);
      props.addFooterActions([
        {
          text: 'Skip for now',
          onClick: props.onNext,
          style: 'outlined'
        },
        {
          text: 'Continue',
          iconRight: 'chevron-right-linear',
          iconColor: 'white',
          onClick: () => {
            modals.setShowSoftwareExport(false);
            modals.setShowProcessingFiles(true);
            props.addFooterActions([
              {
                text: 'Import more',
                onClick: () => {
                  modals.setShowProcessingFiles(false);
                  props.addFooterActions([
                    {
                      goBackHandler: props.onPrev,
                      actions: defaultActions
                    }
                  ]);
                },
                outlined: true
              },
              {
                text: 'Continue',
                onClick: props.onNext,
                iconRight: 'chevron-right-linear',
                iconColor: 'white'
              }
            ]);
          }
        }
      ]);
    }
  };

  return {
    defaultActions,
    handleInitialFormSubmit
  };
};
